import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PropertyInformationComponent } from "../property-information/property-information.component";

@Component({
    selector: 'app-closer-container',
    standalone: true,
    templateUrl: './closer-container.component.html',
    styleUrl: './closer-container.component.scss',
    imports: [CommonModule, MatTabsModule, MatExpansionModule, MatDatepickerModule, MatInputModule, MatFormFieldModule, MatIconModule, MatButtonModule, PropertyInformationComponent]
})
export class CloserContainerComponent {
  userTypes = ['Metadata', 'Sales Comps', 'Rents Comps'];
  @ViewChild(MatAccordion) accordion!: MatAccordion;
}
